import { render, staticRenderFns } from "./AccordionContainer.vue?vue&type=template&id=6466882a&scoped=true"
import script from "./AccordionContainer.vue?vue&type=script&lang=js"
export * from "./AccordionContainer.vue?vue&type=script&lang=js"
import style0 from "./AccordionContainer.vue?vue&type=style&index=0&id=6466882a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6466882a",
  null
  
)

export default component.exports